/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconTrustSgr = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <g fill="green" clipPath="url(#trust_sgr_svg__a)">
        <path d="M11.767 17.034 8.565 15.05a.254.254 0 0 0-.255-.009.241.241 0 0 0-.13.214v1.606h-.722c-2.66-.11-4.743-2.203-4.743-4.766 0-2.562 2.07-4.637 4.705-4.762a247 247 0 0 1 1.78-.006c.34 0 .614-.264.614-.59a.602.602 0 0 0-.614-.59c-.017 0-1.717 0-1.836.006-3.295.155-5.877 2.766-5.877 5.942 0 3.177 2.6 5.809 5.92 5.946l.773.002v1.18c0 .09.05.17.13.213a.256.256 0 0 0 .254-.008l3.201-1.984a.242.242 0 0 0 .117-.204.24.24 0 0 0-.117-.205l.002-.001ZM11.475 6.964l3.202 1.985a.254.254 0 0 0 .255.008.241.241 0 0 0 .13-.214V7.137l.721.001c2.66.109 4.743 2.202 4.743 4.765 0 2.563-2.069 4.637-4.704 4.763-.12.004-1.584.007-1.78.007a.602.602 0 0 0-.614.59c0 .326.274.59.614.59.016 0 1.717 0 1.836-.006 3.296-.157 5.878-2.767 5.878-5.943 0-3.175-2.6-5.808-5.92-5.945l-.773-.003v-1.18c0-.09-.05-.17-.13-.214a.255.255 0 0 0-.254.008l-3.202 1.985a.242.242 0 0 0-.116.204c0 .082.044.16.116.204l-.002.001Z" />
        <path d="M11.422 12.281c1.119 0 2.03-.568 2.03-1.267s-.911-1.266-2.03-1.266c-1.12 0-2.03.567-2.03 1.266 0 .7.91 1.267 2.03 1.267Z" />
        <path d="M13.35 11.8a.064.064 0 0 0-.061.046c-.17.54-.954.931-1.867.931-.914 0-1.698-.391-1.866-.931a.064.064 0 0 0-.062-.045.064.064 0 0 0-.061.045.824.824 0 0 0-.04.247c0 .697.91 1.266 2.03 1.266 1.119 0 2.03-.567 2.03-1.266a.831.831 0 0 0-.04-.247.064.064 0 0 0-.062-.045h-.001Z" />
        <path d="M13.35 12.936a.064.064 0 0 0-.061.045c-.17.54-.954.932-1.867.932-.914 0-1.698-.392-1.866-.932a.064.064 0 0 0-.062-.045.064.064 0 0 0-.061.045.824.824 0 0 0-.04.247c0 .698.91 1.267 2.03 1.267 1.119 0 2.03-.568 2.03-1.267a.831.831 0 0 0-.04-.247.064.064 0 0 0-.062-.045h-.001Z" />
      </g>
      <defs><clipPath id="trust_sgr_svg__a"><path fill="#fff" d="M1.487 4.533h20.267v14.933H1.487z" /></clipPath></defs>
    </svg>
  );
};
export default IconTrustSgr;
